import React, {
  FC,
  createContext,
  Dispatch,
  SetStateAction,
  useState,
  PropsWithChildren,
  useEffect,
} from 'react';

type TSortContext = {
  sort: Nullable<TSort>;
  setSort: Dispatch<SetStateAction<Nullable<TSort>>>;
};

type TSortContextProvider = {
  sessionKey?: string;
};

export const SortContext = createContext<TSortContext>(undefined!);

export const SortContextProvider: FC<PropsWithChildren<TSortContextProvider>> = ({
  sessionKey,
  children,
}) => {
  const rawSort = sessionKey && sessionStorage.getItem(sessionKey);
  const storageSort = rawSort ? JSON.parse(rawSort) : null;

  const initialSort = sessionKey && storageSort ? storageSort : null;

  const [sort, setSort] = useState<Nullable<TSort>>(initialSort);

  useEffect(() => {
    sessionKey && sort && sessionStorage.setItem(sessionKey, JSON.stringify(sort));
  }, [sort, sessionKey]);

  return (
    <SortContext.Provider
      value={{
        sort,
        setSort,
      }}
    >
      {children}
    </SortContext.Provider>
  );
};
